import {
  SiVisa,
  SiAmericanexpress,
  SiPaypal,
  SiZelle,
  SiVenmo,
  SiCashapp,
  SiApplepay,
} from "react-icons/si";
import { FaBuildingColumns, FaMoneyCheckDollar, FaMoneyBillWave } from "react-icons/fa6";

// Original two-tone Mastercard mark (red + amber overlapping circles).
const MastercardLogo = ({ size = 22 }) => (
  <svg viewBox="0 0 40 24" height={size} width={size * (40 / 24)} aria-hidden="true" role="img">
    <defs>
      <clipPath id="mc-left-clip">
        <circle cx="16" cy="12" r="11" />
      </clipPath>
    </defs>
    <circle cx="16" cy="12" r="11" fill="#EB001B" />
    <circle cx="24" cy="12" r="11" fill="#F79E1B" />
    <g clipPath="url(#mc-left-clip)">
      <circle cx="24" cy="12" r="11" fill="#FF5F00" />
    </g>
  </svg>
);

const METHODS = [
  { key: "visa", icon: SiVisa, label: "Visa", color: "#1A1F71" },
  { key: "mastercard", custom: MastercardLogo, label: "Mastercard" },
  { key: "amex", icon: SiAmericanexpress, label: "American Express", color: "#2E77BC" },
  { key: "paypal", icon: SiPaypal, label: "PayPal", color: "#003087" },
  { key: "zelle", icon: SiZelle, label: "Zelle", color: "#6D1ED4" },
  { key: "venmo", icon: SiVenmo, label: "Venmo", color: "#008CFF" },
  { key: "cashapp", icon: SiCashapp, label: "Cash App", color: "#00C244" },
  { key: "applepay", icon: SiApplepay, label: "Apple Pay", color: "#000000" },
  { key: "ach", icon: FaBuildingColumns, label: "ACH", color: "#15306E", text: "ACH" },
  { key: "check", icon: FaMoneyCheckDollar, label: "Checks", color: "#15306E", text: "Check" },
  { key: "cash", icon: FaMoneyBillWave, label: "Cash", color: "#2E7D32", text: "Cash" },
];

// Row of accepted-payment brand marks (no heading).
export const PaymentMethods = ({ className = "" }) => (
  <div
    data-testid="payment-methods"
    className={`flex flex-wrap items-center gap-2 ${className}`}
  >
    {METHODS.map(({ key, icon: Icon, custom: Custom, label, color, text }) => (
      <span
        key={key}
        title={label}
        aria-label={label}
        data-testid={`payment-${key}`}
        className={`inline-flex items-center justify-center gap-1.5 h-8 rounded-md bg-white border border-[#E4E4E7] shadow-sm ${
          text ? "px-2.5" : "w-12"
        }`}
      >
        {Custom ? (
          <Custom size={22} />
        ) : (
          <Icon size={text ? 16 : 22} style={{ color }} aria-hidden="true" />
        )}
        {text && (
          <span className="font-display font-bold text-xs" style={{ color }}>
            {text}
          </span>
        )}
      </span>
    ))}
  </div>
);

export default PaymentMethods;
